export { default } from "./contactDetails";
